import {
  StrategyInterface,
  StrategySelectorContract,
} from '@/types/strategyInterface'
import NoStateNativeScanStrategy from '@/strategies/NoStateNativeScanStrategy'

export default class NoStateNativeScanStrategySelector
  implements StrategySelectorContract
{
  private searchParams

  constructor() {
    this.searchParams = new URLSearchParams(window.location.search)
  }

  can = (): boolean => {
    return this.searchParams.has('uuid') as boolean
  }

  getStrategy = (): StrategyInterface => {
    const { uuid } = this.inputs()
    this.searchParams.delete('uuid')
    return new NoStateNativeScanStrategy(uuid)
  }

  inputs = (): { uuid: string } => {
    return {
      uuid: this.searchParams.get('uuid') as string,
    }
  }
}
